/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1UserRoleStringEnum {
  'userRoleApiIntegrator' = 'api_integrator',
  'userRoleRecruiter' = 'recruiter',
}

export type V1UserRoleString = V1UserRoleStringEnum